import i18next from 'i18next';
import { progressoCurriculo } from './progresso';

export const fotos = function () {
    "use strict";

    var $divPanel = '#avatar-modal';
    var $modal = body.find($divPanel);
    var $avatarView = body.find('.avatar-view');
    var $avatar = $avatarView.find('img');


    var _salvar = function (url) {
        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SalvaFotoRedeSocial', cache: false,
            data: { url: url },
            success: function (data) {
                if (data.state == 200) {
                    toastr.success(i18next.t('fotoSalva'), '', { "closeButton": true });
                    $avatar.attr('src', data.result);
                    $modal.modal('hide');
                    progressoCurriculo();
                }
                else {
                    swal("", data.error, "error");
                }
                window.global.loaderPanel.hide($divPanel);
            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };

    var init = function () {
        //$modal.find('#btn-foto-facebook').on('click', function (e) {
        //    _importarFacebook();
        //    e.preventDefault();
        //});

    }

    return init();
};

